export enum ETipoCalendario {
  padrao,
  exibicaoPublicacoes,
}
